import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      marginTop: '5px',
      height: 'calc(100vh - 350px)',
      border: '1px',
      borderColor: '#cccccc',
      borderStyle: 'solid',
      borderRadius: '5px',
      padding: '5px',
    },
  },
  {
    name: 'UsersTable',
  },
);
